module.exports = __webpack_public_path__ + "static/img/mica-2.7c7be0e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/mica-2.jpg
// module id = pkwO
// module chunks = 1